@import "../../helpers/helpers";

.items {
  padding: 0 14px;
}

.dropzoneObject {
  height: 0;
}

.dropzoneClickable {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 1.4;
  font-size: 42px;
  cursor: pointer;
  height: 56px;
  margin: 7px 14px;

  &:hover {
    opacity: 0.5;
  }

  & > * {
    display: none;
  }

  & > svg {
    display: block;
    pointer-events: none;
  }
}

.dragging {
  border: 3px dashed black;
}

// @keyframes dragging {
//   0% { opacity: 1; }
//   50% { opacity: 0.6; }
//   100% { opacity: 1; }
// }

.added {
  // background: magenta;
}

.uploading {
  // background: purple;
}

.error {
  background: red;
}

.success {
  @include loading;
}

.processed {
  // background: green;
}

.item {
  margin: 14px 0;
  padding: 1px 0;
  width: calc(100% - 8px);
  position: relative;

  &.archivedItemSelected {
    outline: 3px solid gray;
    outline-offset: 2px;
  }
}

:global .sortable-selected {
  outline: 3px solid gray;
  outline-offset: 2px;
}

.progress {
  height: 100%;
  width: 100%;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  border-radius: 4px;
  background: rgba(220, 220, 220, 0.5);
  transition: 0.2s width;
}

.details {
  cursor: context-menu;

  .filename {
    line-height: 1.5;
    word-break: break-word;

    .error & {
      font-size: 80%;
      margin-top: -100px;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
    }

    .filenameArea {
      padding: 6px;
      border: none;
      background: white;

      .added, &,
      .uploading & {
        cursor: default;
      }

      .error & {
        background: red;
      }
    }
  }
}

.archivedItems {
  padding: 0 14px;
  user-select: none;

  .item {
    cursor: pointer;
  }
}

.x {
  position: absolute;
  width: 14px;
  height: 14px;
  display: none;
  padding: 5px;
  top: 7px;
  right: 7px;
  cursor: pointer;
  // background: url(remove.svg);
  background: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4IDgiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Y2xvc2U8L3RpdGxlPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSI3IiBoZWlnaHQ9IjciLz48cGF0aCBkPSJNOCwwLDcuOTkzLDcuOTkzMDYsMCw4Vi4wMTQ4NlpNNy40MjE1Mi41ODM2Ny41ODYuNTk3NTVsLjAwNyw2LjgxMTg0LDYuODQyNTQtLjAwNjk0Wm0tMS4xOTk3NS42ODE3OC41MTQuNTIwMjVMNC41MjE1OSwzLjk2NDgybDIuMjUsMi4yMjE3My0uNTM1NjguNTIwMjVMMy45Nzg4NSw0LjQ5MiwxLjc0Myw2LjcxMzc0LDEuMjIxNCw2LjE4NjU1LDMuNDU3MjcsMy45Nzg2OSwxLjIyODk1LDEuNzkyNjRsLjUyODEzLS41MjcxOUwzLjk5MywzLjQ4MDI0WiIvPjwvc3ZnPg==");
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center;

  .item:hover & {
    display: block;
  }
}
